
import common from '@/tools/common'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
components: {
Grid,
GridItem,
GroupTitle,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem
},
methods: {
},
data () {
return {
GridData: [
{text: '进口税则', link: '/IMGoodsInfoHS', icon: '进口税则.png'},
{text: '出口税则', link: '/OMGoodsInfoHS', icon: '出口税则.png'},
{text: '代征税', link: '/ImportLinkageTax_HS', icon: '代征税.png'},
{text: '出口退税', link: '/ExportRebates_HS', icon: '出口退税.png'},






{text: 'CIQ编码', link: '/CiqSearchListByHS', icon: 'CIQ更新.png'}
]
}
},
beforeCreate: function () {
this.querydata = common.getPower()
},
activated: function () {

},
created: function () {
}
}



// WEBPACK FOOTER //
// ./src/components/TaxLicensed.vue